// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/franklin/digital_wallet.proto (package squareup.franklin.api, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_squareup_common_pii } from "../common/pii_pb";
import type { GlobalAddress } from "../common/location_pb";
import { file_squareup_common_location } from "../common/location_pb";
import { file_squareup_common_governance_v0_semantic_types } from "../common/governance/v0/semantic_types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/franklin/digital_wallet.proto.
 */
export const file_squareup_franklin_digital_wallet: GenFile = /*@__PURE__*/
  fileDesc("CiZzcXVhcmV1cC9mcmFua2xpbi9kaWdpdGFsX3dhbGxldC5wcm90bxIVc3F1YXJldXAuZnJhbmtsaW4uYXBpIs8CChRBcHBsZVBheVBheW1lbnRUb2tlbhIUCgRkYXRhGAEgASgJQgYYAcDrCgESQQoGaGVhZGVyGAIgASgLMjEuc3F1YXJldXAuZnJhbmtsaW4uYXBpLkFwcGxlUGF5UGF5bWVudFRva2VuSGVhZGVyEhcKCXNpZ25hdHVyZRgDIAEoCUIEwOsKARIPCgd2ZXJzaW9uGAQgASgJEhsKDWZpZGVsaXVzVG9rZW4YBSABKAlCBMisBjYSEwoLZGlzcGxheU5hbWUYBiABKAkSGwoJZmlyc3ROYW1lGAcgASgJQgjIrAYSwOsKARIaCghsYXN0TmFtZRgIIAEoCUIIyKwGFMDrCgESSQoOYmlsbGluZ0FkZHJlc3MYCSABKAsyJy5zcXVhcmV1cC5jb21tb24ubG9jYXRpb24uR2xvYmFsQWRkcmVzc0IIyKwGBsDrCgEiqwEKGkFwcGxlUGF5UGF5bWVudFRva2VuSGVhZGVyEh0KD2FwcGxpY2F0aW9uRGF0YRgBIAEoCUIEwOsKARIgChJlcGhlbWVyYWxQdWJsaWNLZXkYAiABKAlCBMDrCgESGAoKd3JhcHBlZEtleRgDIAEoCUIEwOsKARIbCg1wdWJsaWNLZXlIYXNoGAQgASgJQgTA6woBEhUKDXRyYW5zYWN0aW9uSWQYBSABKAki+AEKFUdvb2dsZVBheVBheW1lbnRUb2tlbhIVCgV0b2tlbhgBIAEoCUIGGAHA6woBEhIKCm1lcmNoYW50SWQYAiABKAkSGwoNZmlkZWxpdXNUb2tlbhgDIAEoCUIEyKwGNhITCgtjYXJkRGV0YWlscxgEIAEoCRIbCglmaXJzdE5hbWUYBSABKAlCCMisBhLA6woBEhoKCGxhc3ROYW1lGAYgASgJQgjIrAYUwOsKARJJCg5iaWxsaW5nQWRkcmVzcxgHIAEoCzInLnNxdWFyZXVwLmNvbW1vbi5sb2NhdGlvbi5HbG9iYWxBZGRyZXNzQgjIrAYGwOsKAUI5CiBjb20uc3F1YXJldXAucHJvdG9zLmZyYW5rbGluLmFwaVoVc3F1YXJldXBfZnJhbmtsaW5fYXBp", [file_squareup_common_pii, file_squareup_common_location, file_squareup_common_governance_v0_semantic_types]);

/**
 *
 * An encrypted Apple Pay token as described here:
 * https://developer.apple.com/documentation/passkit/apple_pay/payment_token_format_reference
 *
 * @generated from message squareup.franklin.api.ApplePayPaymentToken
 */
export type ApplePayPaymentToken = Message<"squareup.franklin.api.ApplePayPaymentToken"> & {
  /**
   *
   * Deprecated use [fideliusToken] instead
   *
   * @generated from field: optional string data = 1 [deprecated = true];
   * @deprecated
   */
  data: string;

  /**
   *
   * Additional version-dependent information used to decrypt and verify the payment
   * nullable: false
   *
   * @generated from field: optional squareup.franklin.api.ApplePayPaymentTokenHeader header = 2;
   */
  header?: ApplePayPaymentTokenHeader;

  /**
   *
   * Signature of the payment and header data (detached PKCS #7 signature, Base64 encoded as a string)
   * nullable: false
   *
   * @generated from field: optional string signature = 3;
   */
  signature: string;

  /**
   *
   * Version information about the payment token
   * nullable: false
   *
   * @generated from field: optional string version = 4;
   */
  version: string;

  /**
   *
   * The FideliusToken for the Encrypted payment data (the data stored in fidelius is a Base64 encoded as a string)
   *
   * @generated from field: optional string fideliusToken = 5;
   */
  fideliusToken: string;

  /**
   *
   * The display name provided from the Apple Pay API so that we can extract the last 4 digits of the FPAN
   *
   * @generated from field: optional string displayName = 6;
   */
  displayName: string;

  /**
   *
   * The first name that the customer provided for this digital wallet
   *
   * @generated from field: optional string firstName = 7;
   */
  firstName: string;

  /**
   *
   * The last name that the customer provided for this digital wallet
   *
   * @generated from field: optional string lastName = 8;
   */
  lastName: string;

  /**
   * The customer's billing address.
   *
   * @generated from field: optional squareup.common.location.GlobalAddress billingAddress = 9;
   */
  billingAddress?: GlobalAddress;
};

/**
 * Describes the message squareup.franklin.api.ApplePayPaymentToken.
 * Use `create(ApplePayPaymentTokenSchema)` to create a new message.
 */
export const ApplePayPaymentTokenSchema: GenMessage<ApplePayPaymentToken> = /*@__PURE__*/
  messageDesc(file_squareup_franklin_digital_wallet, 0);

/**
 *
 * Additional version-dependent information used to decrypt and verify the payment
 * https://developer.apple.com/documentation/passkit/apple_pay/payment_token_format_reference#3949539
 *
 * @generated from message squareup.franklin.api.ApplePayPaymentTokenHeader
 */
export type ApplePayPaymentTokenHeader = Message<"squareup.franklin.api.ApplePayPaymentTokenHeader"> & {
  /**
   *
   * Optional. Hash of the applicationData property of the original
   * PKPaymentRequest object for transactions that initiate in apps.
   * For transactions that initiate in Apple Pay on the Web, the value is the hash of
   * applicationData in ApplePayPaymentRequest or of applicationData in ApplePayRequest.
   * (SHA–256 hash, hex encoded as a string)
   * nullable: true
   *
   * @generated from field: optional string applicationData = 1;
   */
  applicationData: string;

  /**
   *
   * Ephemeral public key bytes (X.509 encoded key bytes, Base64 encoded as a string)
   * EC_v1 only.
   * nullable: true
   *
   * @generated from field: optional string ephemeralPublicKey = 2;
   */
  ephemeralPublicKey: string;

  /**
   *
   * The symmetric key wrapped using your RSA public key (A Base64-encoded string)
   * RSA_v1 only.
   * nullable: true
   *
   * @generated from field: optional string wrappedKey = 3;
   */
  wrappedKey: string;

  /**
   *
   * Hash of the X.509 encoded public key bytes of the merchant’s certificate (SHA–256 hash, Base64 encoded as a string)
   * nullable: false
   *
   * @generated from field: optional string publicKeyHash = 4;
   */
  publicKeyHash: string;

  /**
   *
   * Transaction identifier, generated on the device (A hexadecimal identifier, as a string)
   * nullable: false
   *
   * @generated from field: optional string transactionId = 5;
   */
  transactionId: string;
};

/**
 * Describes the message squareup.franklin.api.ApplePayPaymentTokenHeader.
 * Use `create(ApplePayPaymentTokenHeaderSchema)` to create a new message.
 */
export const ApplePayPaymentTokenHeaderSchema: GenMessage<ApplePayPaymentTokenHeader> = /*@__PURE__*/
  messageDesc(file_squareup_franklin_digital_wallet, 1);

/**
 * @generated from message squareup.franklin.api.GooglePayPaymentToken
 */
export type GooglePayPaymentToken = Message<"squareup.franklin.api.GooglePayPaymentToken"> & {
  /**
   *
   * Deprecated use [fideliusToken] instead
   *
   * @generated from field: optional string token = 1 [deprecated = true];
   * @deprecated
   */
  token: string;

  /**
   *
   * Required: True
   * Used to check that the encrypted token
   * was requested by the merchant that is trying to decrypt it.
   * This is required for Google Pay because Panhandler compares
   * the merchantId we provide with the one that comes with the token itself.
   *
   * @generated from field: optional string merchantId = 2;
   */
  merchantId: string;

  /**
   *
   * The FideliusToken for the serialised JSON Google Pay token as described here:
   * https://developers.google.com/pay/api/android/guides/resources/payment-data-cryptography#signed-message
   *
   * @generated from field: optional string fideliusToken = 3;
   */
  fideliusToken: string;

  /**
   *
   * The card details provided from the Google API so that we can extract the last 4 digits of the FPAN
   *
   * @generated from field: optional string cardDetails = 4;
   */
  cardDetails: string;

  /**
   *
   * The first name that the customer provided for this digital wallet
   *
   * @generated from field: optional string firstName = 5;
   */
  firstName: string;

  /**
   *
   * The last name that the customer provided for this digital wallet
   *
   * @generated from field: optional string lastName = 6;
   */
  lastName: string;

  /**
   * The customer's billing address.
   *
   * @generated from field: optional squareup.common.location.GlobalAddress billingAddress = 7;
   */
  billingAddress?: GlobalAddress;
};

/**
 * Describes the message squareup.franklin.api.GooglePayPaymentToken.
 * Use `create(GooglePayPaymentTokenSchema)` to create a new message.
 */
export const GooglePayPaymentTokenSchema: GenMessage<GooglePayPaymentToken> = /*@__PURE__*/
  messageDesc(file_squareup_franklin_digital_wallet, 2);

